import * as React from "react";
import { qaAnswersStore } from "../Stores/QAAnswersStore";
import { QAAnswerItem } from "./QAAnswerItem";
import { observer } from "mobx-react";
import { ModalConsumer } from "Components/General/Modal/ModalContext";
import { modalProps } from "../utils/modalProps";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { QAAnswerEditForm } from "./QAAnswerEditForm";
import { notificationSuccess } from "utils/libHelpers/AntdNotification";

interface QAAnswersProps extends WithTranslation {
  canFetchComments: boolean;
  isCategoryApproval: boolean;
  isSpecialist: boolean;
  isApproval1: boolean;
  isApproval2: boolean;
  isNotInAllQuestionsPage: boolean;
  role: API_QA_ROLE;
  questionId: number;
  canDeclineAnswer: boolean;
  canAcceptAnswer: boolean;
  navigateBack: () => void;
}

export const QAAnswers = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<QAAnswersProps> {
      componentDidMount() {
        const { role } = this.props;
        qaAnswersStore.fetch(undefined, { role });
        // qaAnswersStore.init();
      }

      componentDidUpdate(prevProps: QAAnswersProps) {
        if (prevProps.questionId !== this.props.questionId) {
          const { role } = this.props;
          qaAnswersStore.fetch(undefined, { role });
        }
      }

      componentWillUnmount() {
        qaAnswersStore.clear();
      }

      approveAnswer = async (answerId: number) => {
        const { role, navigateBack } = this.props;
        try {
          const { t } = this.props;
          await qaAnswersStore.approve(answerId, role);
          notificationSuccess(t("Success"), t("Answer was approved"));
          navigateBack();
        } catch (error) {
          throw error;
        }
      };

      rejectAnswer = async (answerId: number) => {
        try {
          const { role, navigateBack } = this.props;
          const { t } = this.props;
          await qaAnswersStore.reject(answerId, role);
          notificationSuccess(t("Success"), t("Answer was rejected"));
          navigateBack();
        } catch (error) {
          throw error;
        }
      };

      render() {
        const { t, role } = this.props;
        return (
          <div>
            {qaAnswersStore.data.map((answer) => (
              <ModalConsumer key={answer.id}>
                {({ showModal }) => (
                  <QAAnswerItem
                    isNotInAllQuestionsPage={this.props.isNotInAllQuestionsPage}
                    isCategoryApproval={this.props.isCategoryApproval}
                    canFetchComments={this.props.canFetchComments}
                    isSpecialist={this.props.isSpecialist}
                    isApproval1={this.props.isApproval1}
                    isApproval2={this.props.isApproval2}
                    canDeclineAnswer={!answer.finalStatus && this.props.canDeclineAnswer}
                    canAcceptAnswer={!answer.finalStatus && this.props.canAcceptAnswer}
                    answerId={answer.id}
                    answer={answer.answer}
                    onApprove={() => this.approveAnswer(answer.id)}
                    onDecline={() => this.rejectAnswer(answer.id)}
                    onEditClick={() =>
                      showModal(QAAnswerEditForm, {
                        modalProps: {
                          ...modalProps,
                          title: t("Edit answer"),
                        },
                        componentProps: { answerId: answer.id, role },
                      })
                    }
                    userId={answer.userId}
                    updated={answer.updated}
                    status={answer.status}
                    attachments={answer.attachments}
                    preliminary={answer.preliminary}
                  />
                )}
              </ModalConsumer>
            ))}
          </div>
        );
      }
    }
  )
);
